/**
 * Every visible string on another fan's profile screen, declared once.
 *
 * Straight ASCII apostrophes only, matching
 * `apps/app/src/features/privacy/privacyScreenLogic.ts`. American English,
 * no en dash, no em dash.
 */

export const FAN_PROFILE_HEADING = "Profile";
export const FAVORITE_TEAMS_TITLE = "Favorite teams";
export const MEDALS_SECTION_TITLE = "Medals and trophies";
export const SCOPE_THIS_SEASON_KEY = "thisSeason";
export const SCOPE_ALL_TIME_KEY = "allTime";
export const SCOPE_THIS_SEASON_LABEL = "This season";
export const SCOPE_ALL_TIME_LABEL = "All-time";
export const SCOPE_TABS_LABEL = "Award period";
export const SHARED_POOLS_TITLE = "Pools you share";
export const SHARED_POOLS_EMPTY = "You don't share any pools yet.";
export const MESSAGE_ACTION_LABEL = "Message";
export const VIEW_PROFILE_ACTION_LABEL = "View profile";
export const MORE_ACTIONS_LABEL = "More";
export const FAN_ACTIONS_TITLE = "Profile actions";
export const BLOCK_ACTION_LABEL = "Block";
export const REPORT_FAN_ACTION_LABEL = "Report";
export const PROFILE_READ_FAILED_LINE =
  "We couldn't load this profile, so blocking isn't available right now.";
export const PROFILE_READ_RETRY_LABEL = "Try again";
export const PROFILE_READ_RETRY_BUSY_LABEL = "Reloading this profile.";
export const PROFILE_READ_PENDING_LABEL = "Loading this profile.";
export { BLOCK_CONFIRM_BODY } from "../messageModeration/moderationCopy";
export const PROFILE_PRIVATE_LINE = "This profile is private.";
export const PROFILE_UNAVAILABLE_LINE = "This profile isn't available.";
export const PROFILE_MISSING_ID_LINE = "No fan was named in this link.";
export const AWARDS_UNAVAILABLE = "Awards aren't available right now.";
export const POOLS_UNAVAILABLE = "Shared pools aren't available right now.";
export const TEAMS_EMPTY = "No favorite teams yet.";

export function blockConfirmTitle(displayName: string): string {
  return `Block ${displayName}?`;
}

export function openFanProfileLabel(displayName: string): string {
  return `Open ${displayName}'s profile`;
}
